/** Safe date display for optional fields — never throws on null/empty. */
export function formatDatePart(value, emptyLabel = 'ثبت نشده') {
    if (value == null || value === '') {
        return emptyLabel;
    }
    const s = String(value).trim();
    if (!s) {
        return emptyLabel;
    }
    return s.split(' ')[0] || emptyLabel;
}

/** Safe text display for optional fields — never throws on null/empty. */
export function displayOrUnset(value, emptyLabel = 'ثبت نشده') {
    if (value == null || value === '') {
        return emptyLabel;
    }
    return value;
}

/** Format react-multi-date-picker DateObject (or plain values) to YYYY/MM/DD. */
export function formatDateObject(date) {
    if (date == null || date === '') {
        return '';
    }
    if (typeof date === 'string') {
        return date;
    }
    if (typeof date.format === 'function') {
        try {
            return date.format('YYYY/MM/DD');
        } catch (e) {
            // fall through
        }
    }
    const year = date.year;
    const day = date.day;
    let month = date.month;
    if (month != null && typeof month === 'object') {
        month = month.number != null ? month.number : month.index != null ? month.index + 1 : month;
    }
    if (year == null || month == null || day == null) {
        return '';
    }
    const mm = String(month).padStart(2, '0');
    const dd = String(day).padStart(2, '0');
    return `${year}/${mm}/${dd}`;
}

/** Add days to a Jalali YYYY/MM/DD string; returns same format or ''. */
export function addDaysToJalali(dateStr, days, DateObjectCls, calendar, locale) {
    if (!dateStr || !DateObjectCls) {
        return '';
    }
    try {
        const d = new DateObjectCls({
            date: String(dateStr).split(' ')[0],
            format: 'YYYY/MM/DD',
            calendar,
            locale,
        });
        d.add(Number(days) || 0, 'days');
        return d.format('YYYY/MM/DD');
    } catch (e) {
        return '';
    }
}

/** Sum numeric amount fields from cleaning-like records. */
export function sumAmounts(rows, field = 'penaltyAmount') {
    return (rows || []).reduce((sum, row) => {
        const raw = row && row[field] != null ? String(row[field]) : '';
        const n = Number(raw.replace(/[^\d.-]/g, ''));
        return sum + (Number.isFinite(n) ? n : 0);
    }, 0);
}

/** Normalize amount/code strings: Persian digits + strip separators. Empty stays empty. */
export function normalizeNumericInput(value) {
    if (value == null) {
        return '';
    }
    let s = String(value);
    s = s.replace(/[۰-۹]/g, (d) => '۰۱۲۳۴۵۶۷۸۹'.indexOf(d).toString());
    s = s.replace(/[٠-٩]/g, (d) => '٠١٢٣٤٥٦٧٨٩'.indexOf(d).toString());
    s = s.replace(/[,\s٬]/g, '');
    return s;
}

export function isOptionalNumber(value) {
    const s = normalizeNumericInput(value);
    return s === '' || /^[0-9]+$/.test(s);
}

export function isRequiredNumber(value) {
    const s = normalizeNumericInput(value);
    return s !== '' && /^[0-9]+$/.test(s);
}

/** Format integer amount with thousand separators for display (Latin digits). */
export function formatDisplayAmount(value) {
    const s = normalizeNumericInput(value);
    if (s === '') {
        return '';
    }
    if (!/^[0-9]+$/.test(s)) {
        return String(value ?? '');
    }
    return Number(s).toLocaleString('en-US');
}

export function formatAmountInputWhileTyping(rawDigits) {
    const s = normalizeNumericInput(rawDigits).replace(/[^0-9]/g, '');
    if (s === '') {
        return '';
    }
    return Number(s).toLocaleString('en-US');
}
